import Position from '../hook/useWindowPosition';
import { ScrollToTop } from "react-simple-scroll-up";
import { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';

export default function Contact() {
  const animated = Position('contact', 0.1);
  const { content } = useContext(LanguageContext);

  return (
    <div className="min-h-screen flex justify-center items-center" id="contact">
      <ScrollToTop className="mt-20">
        <span>UP</span>
      </ScrollToTop>

      <div
        style={{ minHeight: '50vh', background: '#091C29' }}
        className="w-full md:w-4/5 md:rounded-xl shadow-2xl flex md:flex-row flex-col-reverse items-center"
      >
        <img
          src={content.contact?.img}
          alt="profile"
          loading="lazy"
          width="300"
          className="mt-10 transition duration-700 blur-sm hover:blur-0 mx-auto"
        />

        <div className="font-dosis w-4/5 md:w-2/5 mt-5 transition duration-700 md:pr-6 md:pl-1">
          <h1
            className={`${
              animated ? '' : 'translate-y-10 opacity-0'
            } transform transition duration-700 text-white text-5xl font-bold md:text-left text-center mb-6`}
          >
            {content.contact.title}
          </h1>

          {/* ✅ Proper multiline rendering */}
          <div
            className={`${
              animated ? '' : 'translate-y-10 opacity-0'
            } transform transition duration-700 text-white text-lg space-y-3`}
          >
            {content.contact.desc
              .trim()
              .split('\n\n')
              .map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
          </div>

          <div
            className={`flex mt-6 ${
              animated ? '' : 'translate-y-10 opacity-0'
            } transform transition duration-700`}
          >
            {content.contact.socials.map((social, index) => (
              <a
                key={index}
                href={social.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={social.img}
                  alt={social.alt}
                  loading="lazy"
                  width="50"
                  className="m-2 hover:scale-110 transition"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
